import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";
import { X, DownloadSimple, Copy, QrCode } from "@phosphor-icons/react";

export default function QRDialog({ link, url, onClose }) {
  const wrapRef = useRef(null);

  const download = () => {
    const canvas = wrapRef.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `qr_${link.code}.png`;
    document.body.appendChild(a); a.click(); a.remove();
    toast.success("QR code downloaded");
  };

  const copy = () => {
    try { navigator.clipboard.writeText(url); toast.success("Link copied"); }
    catch { toast.error("Copy failed — select and copy manually"); }
  };

  return (
    <div className="fixed inset-0 bg-black/85 flex items-center justify-center p-6 z-50" onClick={onClose}>
      <div className="w-full max-w-sm border border-white/15 bg-[#0a0a0a]" onClick={(e) => e.stopPropagation()} data-testid="qr-dialog">
        <div className="border-b border-white/10 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2"><QrCode size={18} weight="bold" /><h2 className="font-head text-lg font-bold">/r/{link.code}</h2></div>
          <button onClick={onClose} data-testid="close-qr-btn" className="text-zinc-500 hover:text-white transition-colors"><X size={18} /></button>
        </div>
        <div className="p-6 flex flex-col items-center">
          <div ref={wrapRef} className="bg-white p-4 mb-5" data-testid="qr-canvas">
            <QRCodeCanvas value={url} size={220} level="M" includeMargin={false} bgColor="#ffffff" fgColor="#050505" />
          </div>
          <p className="mono text-xs text-zinc-400 break-all text-center mb-5">{url}</p>
          <div className="flex gap-3 w-full">
            <button onClick={copy} data-testid="qr-copy-btn"
              className="flex-1 h-11 border border-white/20 mono text-xs uppercase tracking-wider flex items-center justify-center gap-2 hover:border-white transition-colors">
              <Copy size={15} /> Copy link
            </button>
            <button onClick={download} data-testid="qr-download-btn"
              className="flex-1 h-11 bg-white text-black font-head font-bold text-xs uppercase tracking-wider flex items-center justify-center gap-2 hover:bg-zinc-300 transition-colors">
              <DownloadSimple size={15} weight="bold" /> Download PNG
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
